// @flow

export type Color = {
  r: number,
  g: number,
  b: number,
  a: number  
};

export default class ColorManager {

    colorGrey: Color;
    colorGreen: Color;
    colorLightGreen: Color;
    colorYellow: Color;
    colorOrange: Color;
    colorRed: Color;
    colorViolet: Color;
    colorBlue: Color;
    colorBlue: Color;
    colorLightBlue: Color;
    colorPink: Color;
    colorLightGrey: Color;

    colorTransparent: Color;

    colors: Color[];
    
    colorTraditionalDigging: Color;
    colorInsertionFlexibleLining: Color;
    colorDirectedDrilling: Color;
    colorTubeCracking: Color;
    colorSliplining: Color;
    colorPuLiner: Color;
    
    alphaChartBackground: number;
    alphaChartBackgroundHover: number;
    alphaChartBorder: number;
    alphaChartBorderHover: number;

    colorTubeMaterial: Color;
    colorFilling: Color;
    colorAsphalt: Color;
    colorEnergy: Color;
    colorTransports: Color;
    colorWaste: Color;
    colorRecycle: Color;
    
    constructor() {

        this.alphaChartBackground = 1;
        this.alphaChartBorder = 1;
        this.alphaChartBackgroundHover = 0.9;
        this.alphaChartBorderHover = 0.9;

        this.colorGreen = { r: 0, g: 150, b: 57, a: this.alphaChartBackground }; // From designer brand color
        this.colorLightGreen = { r: 85, g: 196, b: 0, a: this.alphaChartBackground }; // From designer in graph
        this.colorYellow = { r: 199, g: 201, b: 71, a: this.alphaChartBackground };
        this.colorOrange = { r: 201, g: 121, b: 63, a: this.alphaChartBackground };
        this.colorRed = { r: 214, g: 32, b: 32, a: this.alphaChartBackground }; // From designer UI color
        this.colorViolet = { r: 201, g: 60, b: 182, a: this.alphaChartBackground };
        this.colorBlue = { r: 45, g: 70, b: 93, a: this.alphaChartBackground }; // Pollex guide
        this.colorLightBlue = { r: 67, g: 157, b: 240, a: this.alphaChartBackground }; // Pollex guide
        this.colorGrey = { r: 163, g: 163, b: 161, a: this.alphaChartBackground }; // From designer brand color
        this.colorLightGrey = { r: 213, g: 213, b: 211, a: this.alphaChartBackground }; // 
        this.colorPink = { r: 199, g: 21, b: 11, a: this.alphaChartBackground }; // Pollex guide
        this.colorTransparent = { r: 255, g: 255, b: 255, a: 0 };
        
        this.colors = [
            this.colorGrey,
            this.colorGreen,
            this.colorLightGreen,
            this.colorYellow,
            this.colorOrange,
            this.colorRed,
            this.colorViolet,
            this.colorBlue,
            this.colorLightBlue,
            this.colorPink,
        ];
        
        this.colorTraditionalDigging = this.colorPink;
        this.colorInsertionFlexibleLining = this.colorLightGreen;
        this.colorDirectedDrilling = this.colorGreen;
        this.colorTubeCracking = this.colorLightBlue;
        this.colorSliplining = this.colorGrey;
        this.colorPuLiner = this.colorBlue;
        
        this.colorTubeMaterial = this.colorPink;
        this.colorFilling = this.colorGreen;
        this.colorAsphalt = this.colorBlue;
        this.colorEnergy = this.colorLightGreen;
        this.colorTransports = this.colorLightBlue;
        this.colorWaste = this.colorGrey;
        this.colorRecycle = this.colorLightGrey;
    };
    
    getChartColorProperties(color: Color) {
        return {
            backgroundColor: `rgba(${color.r},${color.g},${color.b},${this.alphaChartBackground})`,
            hoverBackgroundColor: `rgba(${color.r},${color.g},${color.b},${this.alphaChartBackgroundHover})`,
            borderColor: `rgba(${color.r},${color.g},${color.b},${this.alphaChartBorder})`,
            hoverBorderColor: `rgba(${color.r},${color.g},${color.b},${this.alphaChartBorderHover})`,
            borderWidth: 0,    
        };
    }
    
    getRgbaString(color: Color) {
        return `rgba(${color.r},${color.g},${color.b},${color.a})`;
    }

    getRgbaStringBorder(color: Color) {
        return `rgba(${color.r},${color.g},${color.b},${this.alphaChartBorder})`;
    }

}


// WEBPACK FOOTER //
// ./src/common/ColorManager.js